import { createFileRoute, Navigate } from '@tanstack/react-router';

import { DailyDigestSection } from '@apps/web/components/settings/activity_feed_section';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/daily-digest')({
    component: DailyDigestPage,
});

function DailyDigestPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings || !gates.dailyDigest) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <SettingsPageShell
            title="Daily digest"
            description="Choose which team members receive the daily digest."
        >
            <DailyDigestSection organizationId={organizationId} />
        </SettingsPageShell>
    );
}
